import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const generateFriendCode = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let s = "";
    for (let i = 0; i < 6; i++) s += chars[Math.floor(Math.random() * chars.length)];
    return s;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // 1. Firebase Auth 생성
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. 프로필 업데이트 (닉네임 설정)
      await updateProfile(user, {
        displayName: nickname,
        photoURL: "" // 기본값 없음
      });

      // 3. Firestore 유저 문서 생성
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: user.email,
        displayName: nickname,
        photoURL: "",
        isAdmin: false,
        friendCode: generateFriendCode(),
        createdAt: new Date(),
        lastLogin: new Date()
      });

      navigate('/');
    } catch (err) {
      console.error("Registration Error:", err);
      setError("회원가입 실패: " + err.message);
    }
  };

  return (
    <>
      <Header />
      <div style={{ maxWidth: "400px", margin: "60px auto", padding: "20px" }}>
        <h2 style={{ textAlign: "center", marginBottom: "24px" }}>회원가입</h2>
        
        <form onSubmit={handleRegister} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <input 
            type="email" 
            placeholder="이메일" 
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{ padding: "12px", borderRadius: "4px", border: "1px solid #ddd" }}
          />
          <input 
            type="password" 
            placeholder="비밀번호 (6자리 이상)" 
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            minLength={6}
            style={{ padding: "12px", borderRadius: "4px", border: "1px solid #ddd" }}
          />
           <input 
            type="text" 
            placeholder="닉네임" 
            value={nickname}
            onChange={e => setNickname(e.target.value)}
            required
            style={{ padding: "12px", borderRadius: "4px", border: "1px solid #ddd" }}
          />
          
          {error && <p style={{ color: "red", fontSize: "0.9rem" }}>{error}</p>}
          
          <button type="submit" className="btn-primary" style={{ padding: "12px", fontSize: "1rem", marginTop: "8px" }}>
            가입하기
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: "24px", color: "#495057" }}>
          이미 계정이 있으신가요? <Link to="/login" style={{ color: "#339af0", textDecoration: "none", fontWeight: "bold" }}>로그인</Link>
        </p>
      </div>
    </>
  );
}

export default Register;
